<template>
  <div class="sysLog">
    <a-card>
      <div class="search" @keyup.enter="getPageList(1)">
        <a-form-model layout="inline" :model="searchForm">
          <a-form-model-item label="时间范围">
            <a-date-picker
              v-model="searchForm.startTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="开始时间"
              style="width: 180px"
            />
            <a-date-picker
              v-model="searchForm.endTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="结束时间"
              style="width: 180px; margin-left: 10px"
            />
          </a-form-model-item>
          <a-form-model-item label="操作类型">
            <a-select
              v-model="searchForm.operationType"
              placeholder="请选择操作类型"
              style="width: 150px"
              allowClear
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="未知">未知</a-select-option>
              <a-select-option value="查询">查询</a-select-option>
              <a-select-option value="添加">添加</a-select-option>
              <a-select-option value="修改">修改</a-select-option>
              <a-select-option value="删除">删除</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="模块名称">
            <a-input
              v-model="searchForm.moduleName"
              placeholder="请输入模块名称"
              style="width: 150px"
            />
          </a-form-model-item>
          <a-form-model-item label="用户名">
            <a-input
              v-model="searchForm.userName"
              placeholder="请输入用户名"
              style="width: 150px"
            />
          </a-form-model-item>
          <a-form-model-item label="应用名称">
            <a-input
              v-model="searchForm.applicationName"
              placeholder="请输入应用名称"
              style="width: 150px"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getPageList(1)" type="primary" html-type="button">查询</a-button>
            <a-button @click="searchReset" style="margin-left: 10px">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div style="overflow: auto; margin-top: 15px">
        <a-table
          style="min-width: 1000px"
          :columns="columns"
          :pagination="tableRelevant.tablePagination"
          :loading="tableRelevant.tableLoading"
          :locale="tableRelevant.locale"
          :dataSource="tableRelevant.tableDataSource"
          :rowKey="(record) => record.id"
        >
          <div slot="exception" slot-scope="text">
            <a-button type="link" @click="showException(text)" v-if="text">查看</a-button>
            <span v-else>-</span>
          </div>
        </a-table>
      </div>
    </a-card>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { SysLog } from '@/utils/http'
import moment from 'moment'

export default {
  name: 'SysLogOperation',
  data() {
    return {
      searchForm: {
        startTime: moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        type: 3, // 操作日志
        pageIndex: 1,
        pageSize: 10,
        userName: undefined,
        applicationName: undefined,
        moduleName: undefined,
        operationType: undefined,
      },
      columns: [
        { title: '日期', dataIndex: 'date', width: 180 },
        { title: '模块名称', dataIndex: 'moduleName', width: 150 },
        { title: '操作名称', dataIndex: 'operationName', width: 150 },
        { title: '操作类型', dataIndex: 'operationType', width: 100 },
        { title: '用户名', dataIndex: 'userName', width: 120 },
        { title: '应用名称', dataIndex: 'applicationName', width: 150 },
        { title: '参数', dataIndex: 'parameter', ellipsis: true },
        { title: '响应', dataIndex: 'response', ellipsis: true },
      ],
      tableRelevant: tableRelevant.call(this, this.getPageList),
    }
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
      return moment(date).format(format)
    },
    formatJson(jsonStr) {
      if (!jsonStr) return ''
      try {
        const parsed = typeof jsonStr === 'string' ? JSON.parse(jsonStr) : jsonStr
        return JSON.stringify(parsed, null, 2)
      } catch (e) {
        return jsonStr
      }
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        startTime: this.searchForm.startTime ? this.formatDate(this.searchForm.startTime, 'YYYY-MM-DD HH:mm:ss') : undefined,
        endTime: this.searchForm.endTime ? this.formatDate(this.searchForm.endTime, 'YYYY-MM-DD HH:mm:ss') : undefined,
        type: this.searchForm.type,
        userName: this.searchForm.userName,
        applicationName: this.searchForm.applicationName,
        moduleName: this.searchForm.moduleName,
        operationType: this.searchForm.operationType,
      }
      this.tableRelevant.tableLoading = true
      SysLog.pageList(params).then((res) => {
        const { data } = res
        this.tableRelevant.tableDataSource = data.items
        this.tableRelevant.tablePagination.total = data.totalCount
        this.tableRelevant.tablePagination.current = data.pageIndex
      }).catch((err) => {
        console.error('获取日志列表失败:', err)
      }).finally(() => {
        this.tableRelevant.tableLoading = false
      })
    },
    searchReset() {
      this.searchForm.startTime = moment().subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss')
      this.searchForm.endTime = moment().format('YYYY-MM-DD HH:mm:ss')
      this.searchForm.userName = undefined
      this.searchForm.applicationName = undefined
      this.searchForm.moduleName = undefined
      this.searchForm.operationType = ''
      this.searchForm.pageIndex = 1
      this.searchForm.pageSize = 10
      this.getPageList()
    },
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 15px;
}
</style>
